export { BaseAvroRecord } from '@chasdevs/avro-to-typescript/dist/src/components/Avro/BaseAvroRecord';